export const BASE_ADMIN_ROUTE = "";
export const ADMIN_LOGIN = "login";
export const REGISTER_ENTRY = "register";
export const MARK_TEAM_ENTRY = "team-entry";
export const LOG_SHEET = "log-sheets";
export const NEW_USER = "new-user";
export const CODE = "code";

export const base_url = "https://api.event-portal.prathameshramane.com";
export const api_route = `${base_url}/api`;